// The one place presence becomes a mark on screen. Offline renders nothing:
// a second colour for "not here" adds noise to every row without telling you
// anything the absence of a dot doesn't.
export function OnlineDot({ online }: { online: boolean }) {
	if (!online) return null
	return (
		<span role="img" aria-label="Online now" title="Online now" class="dot" />
	)
}
